/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { DashboardDossierDto } from './DashboardDossierDto';
import {
    DashboardDossierDtoFromJSON,
    DashboardDossierDtoFromJSONTyped,
    DashboardDossierDtoToJSON,
} from './DashboardDossierDto';
import type { IAggregateResult } from './IAggregateResult';
import {
    IAggregateResultFromJSON,
    IAggregateResultFromJSONTyped,
    IAggregateResultToJSON,
} from './IAggregateResult';

/**
 * 
 * @export
 * @interface DashboardDossierDtoPaginatedResults
 */
export interface DashboardDossierDtoPaginatedResults {
    /**
     * 
     * @type {number}
     * @memberof DashboardDossierDtoPaginatedResults
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<DashboardDossierDto>}
     * @memberof DashboardDossierDtoPaginatedResults
     */
    results?: Array<DashboardDossierDto> | null;
    /**
     * 
     * @type {Array<IAggregateResult>}
     * @memberof DashboardDossierDtoPaginatedResults
     */
    aggregateResults?: Array<IAggregateResult> | null;
}

/**
 * Check if a given object implements the DashboardDossierDtoPaginatedResults interface.
 */
export function instanceOfDashboardDossierDtoPaginatedResults(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function DashboardDossierDtoPaginatedResultsFromJSON(json: any): DashboardDossierDtoPaginatedResults {
    return DashboardDossierDtoPaginatedResultsFromJSONTyped(json, false);
}

export function DashboardDossierDtoPaginatedResultsFromJSONTyped(json: any, ignoreDiscriminator: boolean): DashboardDossierDtoPaginatedResults {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'totalCount': !exists(json, 'totalCount') ? undefined : json['totalCount'],
        'results': !exists(json, 'results') ? undefined : (json['results'] === null ? null : (json['results'] as Array<any>).map(DashboardDossierDtoFromJSON)),
        'aggregateResults': !exists(json, 'aggregateResults') ? undefined : (json['aggregateResults'] === null ? null : (json['aggregateResults'] as Array<any>).map(IAggregateResultFromJSON)),
    };
}

export function DashboardDossierDtoPaginatedResultsToJSON(value?: DashboardDossierDtoPaginatedResults | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'totalCount': value.totalCount,
        'results': value.results === undefined ? undefined : (value.results === null ? null : (value.results as Array<any>).map(DashboardDossierDtoToJSON)),
        'aggregateResults': value.aggregateResults === undefined ? undefined : (value.aggregateResults === null ? null : (value.aggregateResults as Array<any>).map(IAggregateResultToJSON)),
    };
}

